// Copyright (c) Microsoft Corporation.
// Licensed under the MIT License.

export { SearchClient } from "./searchClient.js";
export type {
  AutocompletePostOptionalParams,
  AutocompleteGetOptionalParams,
  IndexOptionalParams,
  SuggestPostOptionalParams,
  SuggestGetOptionalParams,
  GetDocumentOptionalParams,
  SearchPostOptionalParams,
  SearchGetOptionalParams,
  GetDocumentCountOptionalParams,
  SearchContext,
  SearchClientOptionalParams,
} from "./api/index.js";
